import React from 'react';
import s from './styles.module.css'
import Wrapper from "../wrapper";
import {Link, useLocation} from "react-router-dom";

const Footer = () => {
    const {pathname} = useLocation()
    return (
        <div className={s.footer}>
            <Wrapper>
                <div className={s.content}>
                    <h3>ФИНАНСОВЫЙ МАРКЕТПЛЕЙС В РОССИИ</h3>
                    <div className={s.navigate}>
                        <Link to={'/about'} style={{color: pathname === '/about' && '#039be5'}}>О проекте</Link>
                        <Link className={s.second} to={'/advice'} style={{color: pathname === '/advice' && '#039be5'}}>Советы</Link>
                        <Link className={s.second} to={'/conditions'} style={{color: pathname === '/conditions' && '#039be5'}}>Условия получения</Link>
                        <Link className={s.second} to={'/contact'} style={{color: pathname === '/contact' && '#039be5'}}>Обратная связь</Link>
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default Footer;
